import { Avatar } from 'antd';
import { AvatarProps } from 'antd/lib/avatar';
import React from 'react';

export default (props: AvatarProps) => <Avatar {...props} />;
